import { Store } from "@root/data/lib";
import { AuthTenant } from "@root/data/auth/models/auth-tenant";
import { ApiAuthTenant } from "../../../api/clients/mbaas/api";
import { portalServer } from "@root/lib/http";

export interface DeserializedAADAuthTenant extends ApiAuthTenant {
  userId?: string;
}

export interface AadTenantStoreQuery {
  all?: boolean;
}

export class TenantAADStore extends Store<DeserializedAADAuthTenant, ApiAuthTenant, AuthTenant, AadTenantStoreQuery> {
  protected ModelClass = AuthTenant;

  protected generateIdFromResponse(resource: ApiAuthTenant) {
    return resource.name;
  }

  protected getModelId(model: AuthTenant): string {
    return model.name;
  }

  protected async getCollection(
    query?: AadTenantStoreQuery,
    foreignKey?: keyof DeserializedAADAuthTenant,
    subscriptionId?: string
  ): Promise<ApiAuthTenant[]> {
    const params = { all: !!query && query.all ? query.all.toString() : "false" };
    return await portalServer.get("/aad/tenants", { params, noBifrostToken: true });
  }

  protected deserialize(serialized: ApiAuthTenant): DeserializedAADAuthTenant {
    return serialized;
  }
}

export const tenantAADStore = new TenantAADStore();
